import React from 'react';
import { useTranslation } from 'react-i18next';
import { getLocalDateString, parseLocalDate } from '../../utils/dateUtils';

/** Days from local today to the trip's first day (0 = today, negative = started). */
export function daysUntil(trip, today = getLocalDateString(new Date())) {
  const start = (trip.startDate || trip.start_date || '').slice(0, 10);
  if (!start) return null;
  return Math.round((parseLocalDate(start) - parseLocalDate(today)) / 86400000);
}

/**
 * The stage as a chip. Coral is for the countdown and Today only (the one
 * warm moment per region); every other stage is a neutral tag.
 */
export function StageChip({ stage, daysUntil: until }) {
  const { t } = useTranslation('home');
  const warm = 'px-2 h-5 inline-flex items-center rounded-full bg-coral text-coral-ink text-[11px] font-bold whitespace-nowrap';
  const neutral = 'px-2 h-5 inline-flex items-center rounded-full bg-surface-secondary text-content-secondary text-[11px] font-semibold whitespace-nowrap';
  if (stage === 'happening') return <span className={warm}>{t('plans.stage.today')}</span>;
  if (stage === 'ready') return <span className={warm}><Countdown days={until} /></span>;
  if (stage === 'planning') return <span className={neutral}>{t('plans.stage.planning')}</span>;
  if (stage === 'idea') return <span className={neutral}>{t('plans.stage.idea')}</span>;
  if (stage === 'ended') return <span className={neutral}>{t('plans.stage.recapOwed')}</span>;
  return null;
}

/** "In 23 days" / "Tomorrow" / "Today". */
export function Countdown({ days }) {
  const { t } = useTranslation('home');
  if (days === null || days === undefined) return null;
  if (days <= 0) return t('plans.countdown.today');
  if (days === 1) return t('plans.countdown.tomorrow');
  return t('plans.countdown.inDays', { count: days });
}

/** The one fact worth saying about a plan at its stage (tripFact's key + params). */
export function PlanFact({ fact }) {
  const { t } = useTranslation('home');
  if (!fact) return null;
  return t(`plans.fact.${fact.key}`, fact);
}
